export default __webpack_public_path__ + "static/media/poster_18x24in.3dede6a1.png";